export function mapOptions (map) {
  const array = []
  for (const [key] of map) {
    array.push(key)
  }
  return array
}

export function mapTranslatedOption (path) {
  return function mapOption ({ code, id }) {
    return {
      translation: `${path.join('.')}.${code}`,
      text: name,
      value: id
    }
  }
}

export function mapOption ({ name, id }) {
  return {
    text: name,
    value: id
  }
}

export default {
  mapOptions,
  mapTranslatedOption,
  mapOption
}
